<template>
    <div v-loading.fullscreen.lock="fullscreenLoading" class="login-wrapper">
        <el-row type="flex" justify="center" align="center" v-show="visibility" style="height: 100%;">
            <el-col :span="8" class="row vertical-center elCol">
                <el-form v-loading="loading"
                         :inline="false"
                         class="flex-1 login-form customize-label-top-form "
                         :rules="rules"
                         :model="formData"
                         :disabled="disableForm"
                         ref="loginForm">

                    <h3 class="text-center"><label class="login-form-title">ログイン</label></h3>

                    <el-form-item prop="email" :label="$t('login.email')">

                        <el-input ref="email" v-model="formData.email" :placeholder="$t('login.email')"
                                  autocomplete="disabled"
                                  aria-autocomplete="none"></el-input>
                    </el-form-item>

                    <el-form-item prop="username" :label="$t('login.password')">
                        <el-input type="password" v-model="formData.password" :placeholder="$t('login.password')"
                                  @keypress.enter.native="next"></el-input>
                    </el-form-item>

                    <el-form-item style="margin-top: 30px;">
                        <el-button class="custom-button" style="width: 100%;" @click="next">{{$t('login.loginBtn')}}</el-button>
                        <el-button class="custom-button-no-bg register-btn" @click="toRegisterPage">
                            {{$t('login.toRegisterPageBtn')}}
                        </el-button>
                        <el-button class="custom-button-no-bg register-btn" @click="toResetPasswordPage">{{$t('login.toResetPassword')}}</el-button>
                    </el-form-item>
                </el-form>

            </el-col>
        </el-row>
    </div>
</template>

<script>
    import AlertService from "@/service/alert.service";
    import Pages from '@/router/Pages';
    import LoginApi from '@/api/login/LoginApi';
    import StorageManager from "../../security/StorageManager";

    export default {
        name: "Login",
        data() {
            return {
                rules: {
                    email: [
                        {required: true, message: this.$t("common.requiredMessage"), trigger: "blur"}
                    ],
                    password: [
                        {required: true, message: this.$t("common.requiredMessage"), trigger: "blur"}
                    ]
                },
                formData: {
                    password: "",
                    email: ""
                },
                disableForm: false,
                loading: false,
                visibility: true,
                fullscreenLoading: false,
            }
        },
        mounted() {
            console.log("Request url:")
            console.log(StorageManager.getItem("to"))
            this.$refs["email"].focus();
        },
        methods: {
            toRegisterPage() {
                this.$router.push({path: Pages.register.path});
            },
            toResetPasswordPage(){
                this.$router.push({path: Pages.resetPassword.path});
            },
            show() {
                this.visibility = true;
                this.disableForm = false;
            },
            hide() {
                this.visibility = false;
                this.disableForm = true;
            },
            next() {
                let vue = this;
                vue.$refs["loginForm"].validate(async valid => {
                    AlertService.setDisabled(false);
                    if (valid) {
                        let data = {
                            username: vue.formData.email,
                            password: vue.formData.password
                        };
                        try {
                            vue.loading = true;
                            vue.disableForm = true;
                            const response = await LoginApi.login(data);
                            this.$auth.setCurrentUser(response.endUserEntity);
                            await vue.$router.push({path: Pages.redirect.path});
                        } catch (e) {
                            if (e.response.status == 400) {
                                AlertService.error(this.$t("login.loginFailMessage"));
                            } else {
                                AlertService.error(this.$t("common.serverErrorMessage"), 2000);
                            }
                        } finally {
                            vue.loading = false;
                            vue.disableForm = false;
                        }
                    }
                });
            }
        }

    }
</script>

<style lang="scss" scoped>
    /deep/ .login-form-title {
        display: inline-block;
        padding-bottom: 5px;
    }

    .elCol {
        width: revert;
    }

    .login-wrapper {
        height: 100%;
    }

    .login-form {
        border-radius: 50px;
        border: 1px solid #4B86E8;
        padding: 20px 40px;
    }

    /deep/ .login-form .el-form-item {
        margin-bottom: 10px !important;
    }

    .register-btn {
        width: 100%;
        margin-left: 0 !important;
        margin-top: 10px;
        //margin-bottom: 40px !important;
    }

    @media (max-width: 768px) {
        .login-form {
            border: none;
            padding: 0px;
        }
        .elCol {
            width: 100%;
        }
    }
</style>
